import React, { useState, createContext, useContext } from "react";

// context for managing registration data in Register screen
const initalState = {
  clientName: 'All',
};

export const ClientContext = createContext();

export const ClientProvider = ({ children }) => {
  const [clientGroup, setClientGroup] = useState("Pertamina");
  const [clientName, setClientName] = useState("All");

  return (
    <ClientContext.Provider 
      value={{ 
        clientName, 
        setClientName, 
        clientGroup, 
        setClientGroup 
      }}
    >
      {/* {renderComponent()} */}
      {children}
    </ClientContext.Provider>
  );
};

export const useClientContext = () => useContext(ClientContext);
